import type * as User from './User'
import type { AtomMut } from '@reatom/framework'

interface LoggedInAuthState {
  type: 'LoggedIn'
  user: AtomMut<User.User>
}
interface InitialAuthState {
  type: 'Initial'
}
interface SessionExpiredAuthState {
  type: 'SessionExpired'
  user: User.User
}

export type AuthState =
  | InitialAuthState
  | SessionExpiredAuthState
  | LoggedInAuthState

export const isLoggedIn = (state: AuthState): state is LoggedInAuthState =>
  state.type === 'LoggedIn'

export const isInitial = (state: AuthState): state is InitialAuthState =>
  state.type === 'Initial'

export const isSessionExpired = (
  state: AuthState,
): state is SessionExpiredAuthState => state.type === 'SessionExpired'

export const initial = (): AuthState => ({
  type: 'Initial',
})

export const sessionExpired = (user: User.User): AuthState => ({
  type: 'SessionExpired',
  user,
})
